export default ({ icon, ...restProps }) => {
  return (
    <div
      {...restProps}
      style={{
        border: "1px solid #ccc",
        padding: 16,
        cursor: "pointer",
        backgroundColor: "white",
        borderRadius: 5,
        height: 89,
        marginBottom: 16,
      }}
    >
      {icon} 
    </div>
  );
};
